export default __webpack_public_path__ + "tmp_src/components/ShopLocalization/ShopLocalization~aurora.css.liquid";